<!-- Empty state -->
<div *ngIf="!schedulingData()" class="container inner-shadow container-empty-state d-flex justify-content-center flex-column align-items-center">
  <form [formGroup]="meetingContactSelectionForm" class="text-center" (submit)="sendMeetingContactSelectionForm()">

    <p><fa-icon [icon]="icons.calendarDays" class="display-1 text-primary"></fa-icon></p>

    <h3 class="text-primary">Agendar ou alterar reunião</h3>

    <p class="lead">Agende ou altere uma reunião para um contato já registrado no Hubspot. O contato deverá estar associado a um negócio em andamento no Pipeline de pré-vendas.</p>

    <input type="email" class="form-control form-control-lg" required id="inputName" placeholder="exemplo@gmail.com" formControlName="contactEmail">

    <div class="form-row mt-3">
      <div class="form-group">
        <button type="submit" [disabled]="!meetingContactSelectionForm.valid || loadingSchedulingData()" class="btn  btn-secondary">{{loadingSchedulingData() ? 'Aguarde...' : 'Buscar contato'}}</button>
      </div>
    </div>
  </form>
</div>


<div *ngIf="schedulingData() as data" class="container-fluid h-100 inner-shadow pt-3">
  <div class="row h-100">
    <div class="col-2">

      <app-meetings-profile [schedulingData]="data"></app-meetings-profile>

      <ul class="meeting-menu nav flex-column nav-pills mt-4">
        <li class="nav-item meeting-menu-item"><a routerLink="/reunioes/lista/" [queryParams]="{contato: data.contact.email}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link"><fa-icon [icon]="icons.calendars" class="me-2"></fa-icon> Todas as reuniões <span *ngIf="data.meetings.length" class="badge bg-pink rounded-pill">{{data.meetings.length}}</span></a></li>
        <li class="nav-item meeting-menu-item"><a routerLink="/reunioes/nova/" [queryParams]="{contato: data.contact.email}"  routerLinkActive="active" class="nav-link"><fa-icon [icon]="icons.calendarCirclePlus" class="me-2"></fa-icon> Nova reunião</a></li>
      </ul>
    </div>

    <div class="col">
      <router-outlet (activate)="onOutletLoaded($event)"></router-outlet>
    </div>
  </div>
</div>
